import { FleekError } from './FleekError';

type UserNotFoundErrorOptions = {
  id?: string;
  email?: string;
};

export class UserNotFoundError extends FleekError<UserNotFoundErrorOptions> {
  public name = 'UserNotFoundError';

  toString = () => {
    if (this.data.email) {
      return `User with email ${this.data.email} not found.`;
    }

    return `User not found.`;
  };
}
